"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { createContext } from "react";
import { jsx } from "react/jsx-runtime";
import { FloatingDelayGroup } from "@floating-ui/react";
//#region packages/@mantine/core/src/components/Tooltip/TooltipGroup/TooltipGroup.tsx
const TooltipGroupContext = createContext({ withinGroup: false });
const defaultProps = {
	openDelay: 0,
	closeDelay: 0
};
function TooltipGroup(props) {
	const { openDelay, closeDelay, children } = useProps("TooltipGroup", defaultProps, props);
	return /* @__PURE__ */ jsx(TooltipGroupContext, {
		value: { withinGroup: true },
		children: /* @__PURE__ */ jsx(FloatingDelayGroup, {
			delay: {
				open: openDelay,
				close: closeDelay
			},
			children
		})
	});
}
TooltipGroup.displayName = "@mantine/core/TooltipGroup";
TooltipGroup.extend = (c) => c;
//#endregion
export { TooltipGroup, TooltipGroupContext };

//# sourceMappingURL=TooltipGroup.mjs.map